// extracted by mini-css-extract-plugin
module.exports = {"box":"_crossplatform-styles-module--box--2kOi6","container":"_crossplatform-styles-module--container--1xEyy","graphic":"_crossplatform-styles-module--graphic--1VlUF"};